import axios from 'axios'
import type {
  SessionCreateRequest,
  SessionCreateResponse,
  SessionResponse,
  TwoFactorVerifyRequest,
} from 'types'

export const sessionCreate = (data: SessionCreateRequest) =>
  axios
    .post<SessionCreateResponse>('/api/sessions', data)
    .then((res) => res.data)

export const sessionGet = () =>
  axios.get<SessionResponse>('/api/sessions').then((res) => res.data)

export const sessionLogout = () =>
  axios.delete<void>('/api/sessions').then((res) => res.data)

export const session2FAVerify = (data: TwoFactorVerifyRequest) =>
  axios.post<SessionResponse>('/api/sessions/2fa', data).then((res) => res.data)

export const session2FAResend = () =>
  axios.post<void>('/api/sessions/2fa/resend').then((res) => res.data)
